<section class="container gallery-section" aria-labelledby="gallery-title" itemscope
  itemtype="https://schema.org/ImageGallery">
  <!-- METADATOS INVISIBLES AEO PARA BÚSQUEDA Y MOTOR DE RESPUESTAS IA -->
  <meta itemprop="name" content="Galería Fotográfica Histórica de Estancos Distilling Co." />
  <meta itemprop="description"
    content="Colección fotográfica del proceso artesanal, alambiques de cobre y barricas de roble a 2500 msnm en los Andes." />

  <header class="section-header">
    <span class="section-subtitle">Momentos Inmortales & Patrimonio</span>
    <h2 id="gallery-title">Galería Estancos</h2>
    <p class="section-lead-text">
      Un recorrido visual por la alquimia, la pasión y la herencia colonial que dan vida a nuestros espirituosos de
      altura.
    </p>
  </header>

  <!-- ESTADO DE CARGA ACCESIBLE -->
  @if (isLoading()) {
  <div class="loader-container" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <div class="loader-text">Revelando Galería Fotográfica...</div>
  </div>
  } @else {

  <!-- GRID DE IMÁGENES MASONRY CON NAVEGACIÓN Y CARGA ULTRA RÁPIDA -->
  <div class="gallery-grid" role="list">
    @for (img of images(); track img.url; let i = $index) {

    <article class="gallery-item" [class]="img.sizeClass" (click)="openLightbox(img)" role="listitem" itemprop="image"
      itemscope itemtype="https://schema.org/ImageObject" tabindex="0" (keyup.enter)="openLightbox(img)"
      [attr.aria-label]="'Ver imagen ampliada: ' + img.title">
      <meta itemprop="position" [content]="i + 1" />
      <meta itemprop="name" [content]="img.title" />
      <meta itemprop="caption" [content]="img.alt" />
      <meta itemprop="description" [content]="getFormattedSemanticDescription(img)" />
      <meta itemprop="contentUrl" [content]="img.url" />

      <!-- Carga optimizada: Miniaturas livianas con lazy loading inteligente y prioridad alta en las primeras -->
      <img [src]="img.thumbUrl || img.url" [alt]="img.alt" [attr.loading]="i < 4 ? 'eager' : 'lazy'"
        [attr.fetchpriority]="i < 2 ? 'high' : 'auto'" decoding="async" (error)="onImageError($event)">

      <!-- SUPERPOSICIÓN E ICONO LUPA DE LENTE NEOCLÁSICA -->
      <div class="overlay" aria-hidden="true">
        <div class="overlay-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <span>Ampliar Imagen</span>
        </div>
        <h3 class="item-title">{{ img.title }}</h3>
      </div>
    </article>

    }
  </div>

  }

  <!-- LIGHTBOX MODAL NEOCLÁSICO DE ALTA ACCESIBILIDAD Y AEO -->
  <div class="lightbox-overlay" [class.active]="selectedImage() !== null" (click)="closeLightbox($event)" role="dialog"
    aria-modal="true" [attr.aria-hidden]="selectedImage() === null">
    @if (selectedImage(); as currentImg) {
    <div class="lightbox-content" (click)="$event.stopPropagation()">

      <button class="lightbox-close" (click)="closeLightbox($event)" aria-label="Cerrar visor de fotografía">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div class="lightbox-media-frame">
        <img [src]="currentImg.url" [alt]="currentImg.alt" class="lightbox-img" loading="eager" decoding="async"
          (error)="onImageError($event)">
      </div>

      <div class="lightbox-details">
        <h3 class="lightbox-caption">{{ currentImg.title }}</h3>
        <p class="lightbox-description">{{ currentImg.alt }}</p>

        <!-- BLOQUE DE TRIPLETAS SEMÁNTICAS EN LIGHTBOX (AEO) -->
        <div class="semantic-triplets-box" aria-label="Atributos históricos de la imagen">
          <span class="triplets-header-title">Atributos Históricos</span>
          <ul class="triplets-list">
            @for (triplet of getSemanticTriplets(currentImg); track $index) {
            <li class="triplet-item" itemscope itemtype="https://schema.org/PropertyValue">
              <span class="triplet-subject" itemprop="name">{{ triplet.subject }}</span>
              <span class="triplet-predicate">{{ triplet.predicate }}</span>
              <span class="triplet-object" itemprop="value">{{ triplet.object }}</span>
            </li>
            }
          </ul>
        </div>
      </div>

    </div>
    }
  </div>

</section>